import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_ctx.keyActive || _ctx.$lye(_ctx.assetKey))
    ? (_openBlock(), _createBlock(_component_lyra_asset, {
        key: 0,
        class: _normalizeClass(["hd-asset-content", `hd-asset-content__${_ctx.endpointId}`]),
        "asset-key": _ctx.assetKey
      }, null, 8, ["class", "asset-key"]))
    : _createCommentVNode("", true)
}